var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProducerSolid = function SvgProducerSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.003 2a1 1 0 1 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0V7h3a1 1 0 1 0 0-2h-3V2Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.969a4 4 0 0 0-4 4v8.002c0 2.209 1.79 4 3.997 4H11v1.998H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3V18.97h5.987A4 4 0 0 0 23 14.969c0-2.166.006-3.31 0-5.475 0 0-.086-.539-.586-.539l-1.405-.002.003.002v1.032c-.054 1.015-.244 1.34-.86 2.087-.55.668-1.463.887-2.166.89l.005-.003c-1.078-.031-1.78-.42-2.402-1.203-.44-.553-.556-1.243-.581-1.703V8.953h-1.061c-.904-.066-1.548-.349-2.158-.969-.467-.523-.656-1.015-.732-1.414-.12-1.007-.114-1.852.443-2.601.177-.239.5-1-.5-1H5Z",
    fill: "currentcolor"
  })));
};
export default SvgProducerSolid;